import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { validationMessages } from 'constants/validation'

import { InviteResult, usePostInviteApploval } from 'interface/user/invite'

import { FormHelperText, Stack, Typography } from '@mui/material'
import { Section } from 'components/controls/section'
import { GroupResult } from 'interface/user/group'
import { OptionSelect } from 'components/controls/optionSelect'
import { MailAddress } from 'features/kojin/components/mailAddress'
import { MarkdownPreview } from 'components/controls/markDownPreview'

const {
  Required
} = validationMessages

const formSchema = yup.object().shape({
  groups: yup.array()
    .min(1, Required)
    .required(Required)
})

type useInviteApplovalFormProps = {
  invite: InviteResult,
  groupList: GroupResult[],
  onApplovaled: (applovaledId: number) => void
}
export const useInviteApplovalForm = ({
  invite,
  groupList,
  onApplovaled
}: useInviteApplovalFormProps) => {
  const form = useForm({
    defaultValues: invite ? {
      groups: invite.groups.map(group => group.groupId)
    } : {
      groups: []
    },
    mode: 'onChange',
    criteriaMode: 'all',
    resolver: yupResolver(formSchema)
  })
  const [applovalState, apploval] = usePostInviteApploval({
    onPosted: onApplovaled
  })
  return {
    ...form,
    invite,
    groupList,
    posting: applovalState.posting,
    error: applovalState.error,
    apploval: form.handleSubmit(input => apploval({
      inviteId: invite.inviteId,
      form: {
        groups: input.groups
      }
    }))
  }
}

export const InviteApplovalForm = ({
  invite,
  groupList,
  control,
  formState: { errors }
}: ReturnType<typeof useInviteApplovalForm>) => {
  return (
    <Stack direction="column">
      <Section label="ユーザー名">
        <Typography variant='body1'>{invite.userName}</Typography>
      </Section>

      <Section label="メールアドレス">
        <MailAddress address={invite.email} mailStatus='OK'/>
      </Section>

      <Section label="申請時コメント">
        <MarkdownPreview value={invite.comment} padding={0}/>
      </Section>

      <Section label="割当グループ" labelProps={{ py: 2 }}>
        <Controller
          control={control}
          name="groups"
          render={({field}) => (
            <>
              <OptionSelect
                {...field}
                variant="outlined"
                size="small"
                optionList={(groupList ?? []).map((group) => ({
                  id: group.groupId,
                  label: group.groupName
                }))}
              />
              {errors.groups && (
                <FormHelperText error>{errors.groups.message}</FormHelperText>
              )}
            </>
          )}
        />  
      </Section>
    </Stack>
  )
}
